import {BUYERS_FAILED, RECEIVE_BUYERS, REQUEST_BUYERS} from "../actions/types";

function buyersRequest(state = {}, action) {
  switch (action.type) {
    case RECEIVE_BUYERS:
      return Object.assign({}, state, {
        isFetching: false,
        buyers: action.payload,
        error: null
      });
    case REQUEST_BUYERS:
      return Object.assign({}, state, {
        isFetching: true,
        buyers: {},
        error: null
      });
    case BUYERS_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        buyers: null,
        error: action.error
      });
    default: {
      return state;
    }
  }
}

export default buyersRequest;
